<app-header [title]="title" [subtitle]="subtitle"></app-header>

<main>
    <article>

        <section>
          <div class="description">
            <p  >{{styles.selected.description}}</p>
          </div>
            <div class="img-clip">

                <img src="{{styles.selected.knaufProject.image}}" alt="">
            </div>
        </section>




        <ul class="palettes">
            <li *ngFor="let item of styles.items" [ngClass]="{'selected': styles.selected==item}"
                (click)="onStyleClick(item)" class="{{item.class}}">{{item.name}}</li>
        </ul>


      <div class="mobile-tabs">
        <div [ngClass]="{'active': mobileActionActive==0}" (click)="onMobileActionActive(0)"  >Akcje</div>
        <div [ngClass]="{'active': mobileActionActive==2}" (click)="onMobileActionActive(2)"  >Palety</div>
        <!-- <div [ngClass]="{'active': mobileActionActive==1}" (click)="onMobileActionActive(1)"  >Opis</div> -->

      </div>




        <section class="colors-section" [ngClass]="{'tab-active': mobileActionActive==2}">
            <div class="color-set">
                <h3  >CAŁA PALETA KOLORYSTYCZNA {{styles.selected.palette.name}}</h3>
                <div class="colors basic"
                    [ngClass]="{'allcolors': styles.selected.knaufPalette == KnaufPalettes.WszystkieKolory, 'active': mobileColorsActive==0}">
                    <h4   (click)="mobileSelectColorsActive(0)">Kolory podstawowe</h4>
                    <div class="blocks">
                        <span *ngFor="let color of styles.selected.palette.basic" [ngStyle]="{'background': color.rgb}"
                            [title]="color.code"></span>
                    </div>
                </div>
                <div class="colors extended" *ngIf="styles.selected.knaufPalette != KnaufPalettes.WszystkieKolory"
                    [ngClass]="{'active': mobileColorsActive=='1'}">
                    <h4   (click)="mobileSelectColorsActive(1)">Kolory uzupełniające</h4>
                    <div class="blocks">
                        <span *ngFor="let color of styles.selected.palette.extended"
                            [ngStyle]="{'background': color.rgb}" [title]="color.code"></span>
                    </div>
                </div>
                <div class="colors accent" *ngIf="styles.selected.knaufPalette != KnaufPalettes.WszystkieKolory"
                    [ngClass]="{'active': mobileColorsActive==2}">
                    <h4   (click)="mobileSelectColorsActive(2)">Akcenty</h4>
                    <div class="blocks"><span *ngFor="let color of styles.selected.palette.accent"
                            [ngStyle]="{'background': color.rgb}" [title]="color.code"></span>
                    </div>
                </div>
            </div>
        </section>
        <aside>

          <div class="description" [ngClass]="{'tab-active': mobileActionActive==1}">
            <h3 class="medium"  >Dla kogo?</h3>
            <p>{{styles.selected.forWhom}}</p>
            <h3 class="medium"   >Proponowane kolory</h3>
            <div>

              <ul *ngIf="project.selectedColors.length">
              <li *ngFor="let color of project.selectedColors"><span
                [ngStyle]="{'background': color.rgb}"></span>{{color.code}}</li>
              </ul>
            </div>
          </div>
          <div class="actions col-xs-12" [ngClass]="{'tab-active': mobileActionActive==0}">
            <div class="akcje">

            <button (click)="addProjectToCompare()" class="btn btn-primary btn-fw" type="button" block="true" color="primary" >
              <fa-icon [icon]="faPlus"></fa-icon>
              Dodaj do moich projektów
            </button>
            <button (click)="onEditClick()" class="btn btn-green btn-fw" type="button"   >
              <fa-icon [icon]="faEdit"></fa-icon>
              Edytuj - zmień kolory
            </button>
              <button type="button" class="btn  btn-success btn-fw   btn-block mt-3 waves-effect waves-light" [routerLink]="next"
                    >Dalej</button>

            </div>

          </div>


        </aside>

    </article>
</main>
<!--<app-footer [next]="next"></app-footer>-->

<jw-modal id="warning-dlg">
    <div class="warningdlg messagebox">
        <button class="dlg-closebutton"><img src="assets/ikony/aplikacja-ikony-18.png"   alt="Zamknij"
                (click)="closeModal('warning-dlg')"></button>
        <p  >Możesz dodać jedynie 2 projekty do porównania. Jeżeli chcesz dodać kolejny, przejdź do widoku "Moje
            projekty" i usuń któryś z już istniejących.<br/></p>
        <div class="buttons">
            <button class="btn btn-primary " (click)="goToMyProjects()">
              Przejdź do moich projektów
            </button>
            <button class="btn btn-success " (click)="closeModal('warning-dlg')">
                <div class="content">OK</div>
            </button>
        </div>
    </div>
</jw-modal>

<jw-modal id="confirmation-dlg">
    <div class="messagebox">
        <button class="dlg-closebutton"><img src="assets/ikony/aplikacja-ikony-18.png"   alt="Zamknij"
                (click)="closeModal('confirmation-dlg')"></button>
        <p  >Twój projekt został dodany do porównania</p>
        <div class="buttons">
            <button class="btn btn-success accept " (click)="closeModal('confirmation-dlg')">
                <div class="content"><img src="assets/ikony/aplikacja-ikony-13.png">OK</div>
            </button>
        </div>
    </div>
</jw-modal>

<jw-modal id="editor-dlg">
    <div class="messagebox">
        <button class="dlg-closebutton"><img src="assets/ikony/aplikacja-ikony-18.png"    alt="Zamknij"
                (click)="closeModal('editor-dlg')"></button>
        <p  >Masz już 2 zapisane projekty. Aby dodać do porównania następny projekt – musisz przynajmniej jeden z
            nich usunąć.</p>
        <div class="buttons">
            <button mdbBtn type="button" color="default" block="true" (click)="goToMyProjects()">
              Przejdź do moich projektów
            </button>
            <button class="accept btn btn-sm btn-primary" (click)="goToEditor()">
              Edytuj
            </button>
        </div>
    </div>
</jw-modal>
